import { DocumentTypes } from '../Interfaces/Draft/DraftInterface'
import { isRecurring } from './helpers/recurringProfile'
import { setNavigation } from './navigation'

export const closeEditor = () => {
  return async (dispatch, getState) => {
    const { draft, navigation, recurringProfile } = getState()
    const navOrigin = navigation.origin === ('/reactDashboard' || '/') ? navigation.origin : null
    const {
      document,
      id,
      fields: { approvedInvoiceId },
    } = draft
    const mod = document === DocumentTypes.ESTIMATE ? 'reactEstimateList' : 'reactInvoiceList'
    const invoiceId =
      // eslint-disable-next-line no-nested-ternary
      document === DocumentTypes.CREDITNOTE ? (approvedInvoiceId ? approvedInvoiceId.value : null) : null
    const isRecurringProfile = isRecurring(draft)
    const path =
      navOrigin ||
      // eslint-disable-next-line no-nested-ternary
      (isRecurringProfile
        ? recurringProfile.id
          ? `/reactRecurringProfiles/${recurringProfile.id}`
          : '/reactRecurringProfiles'
        : invoiceId
          ? `/${mod}/invoice/${invoiceId}`
          : `/${mod}`)
    dispatch(
      setNavigation({
        path,
        app: {
          mod,
          id,
          type: document,
          invoiceEditorLoading: false,
        },
      }),
    )
  }
}
